import { Theme } from "@mui/material/styles";

export const getInactiveChannelItemStyles = (theme: Theme) => ({
    borderLeft: `3px solid ${theme.palette.grey[300]}`,
    textColor: theme.palette.text.secondary,
    avatar: {
        opacity: 0.5,
        filter: "grayscale(1)",
    },
});

export const getClosedChannelItemStyles = (theme: Theme) => ({
    borderLeft: `3px solid ${theme.palette.grey[400]}`,
    textColor: theme.palette.text.secondary,
    avatar: {
        filter: "grayscale(1)",
    },
});
